import useNRQuery from '../../graphql/useNRQuery';
import ReachabilityComponent from './NRreachability';

function NRReachabilityEvidenceContainer({ query, variables, qlObjKey, componentName, severityColor, terminalSubtitle = 'Component', terminalIcon }) {
  const [reachabilityData, reachabilityLoading] = useNRQuery({
    query,
    options: { variables, context: { version: 'v3' } },
    qlObjKey,
    defaultValue: []
  });

  return (
    <ReachabilityComponent
      componentName={componentName}
      reachabilityData={reachabilityData}
      isLoading={reachabilityLoading}
      severityColor={severityColor}
      terminalSubtitle={terminalSubtitle}
      terminalIcon={terminalIcon}
    />
  );
}

export default NRReachabilityEvidenceContainer;
